import { useState } from "react";
import Logo from "./navbar/logo";
import { useNavigate, useParams } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { getSignInLink } from "../../utils/path-helper";
import "./navbar/btns-group.scss";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faBars } from "@fortawesome/free-solid-svg-icons";
import HelpGuideModal from "./help-guide";
import { getPortalCD } from "../../utils/helpers";

const PSHeader = ({ isLogoDisabled }) => {
  const navigate = useNavigate();
  const { locale } = useParams();
  let signInLink = getSignInLink(locale, window.location.search);
  const [mobileviewNavbar, setMobileviewNavbar] = useState(false);
  const { t } = useTranslation();
  const [isHelpGuideVisible, setIsHelpGuideVisible] = useState(false);
  const portalCD = getPortalCD(locale);
  const toggleHelpGuide = () => {
    if (window.location.href.includes("forgot-password")) {
      navigateSignIn();
    } else {
      setIsHelpGuideVisible((prev) => !prev);
    }
  };
  const navigateSignIn = () => {
    navigate(signInLink);
  };

  return (
    <>
      <header className="header border-b border-[#DBDEE1] h-[75px] md:h-[86px] py-[15px] md:py-[20px] flex justify-between">
        <nav className="container mx-auto ">
          <div className="flex justify-between items-center w-full">
            <div>
              <Logo disabled={isLogoDisabled} />
            </div>
            <div id="navbarNavAltMarkup">
              <div className="flex pr-1.5 items-center lg:-mt-[6px]">
                {portalCD !== "PSSC" && (
                  <button
                    id="help-guide-btn"
                    className={`bg-[#0E77FF] h-[42px] md:h-[46px] text-white rounded-[100px] py-[12px] text-center align-middle gap-[10px] font-bold text-sm md:text-base leading-[100%] 
                    ${locale === "vi" ? "px-5 min-w-[160px] whitespace-nowrap" : "w-[140px]"}`}
                    onClick={toggleHelpGuide}
                  >
                    {t("generic_text.help_guide")}
                  </button>
                )}
                <button
                  className="hidden text-gray-400 text-2xl sm:text-3xl sm:mr-2"
                  onClick={() => setMobileviewNavbar((prev) => !prev)}
                >
                  <FontAwesomeIcon icon={faBars} />
                </button>
              </div>
            </div>
          </div>
          <div
            className={`w-full lg:hidden transition-all duration-1000 ease-in-out font-bold ${
              mobileviewNavbar ? "max-h-20 opacity-100" : "max-h-0 opacity-0"
            }`}
          >
            <button
              className="text-base border rounded border-[#fdce43] hover:border-[#424a5b] bg-[#fdce43] hover:bg-[#424a5b] text-[#424a5b] hover:text-white font-medium py-3 px-4 w-full text-center mt-4"
              onClick={toggleHelpGuide}
            >
              {window.location.href.includes("forgot-password")
                ? t("sign_up.ps.member_login")
                : t("generic_text.help_guide")}
            </button>
          </div>
        </nav>
      </header>
      <HelpGuideModal toggleHelpGuide={toggleHelpGuide} isHelpGuideVisible={isHelpGuideVisible} />
    </>
  );
};

export default PSHeader;
